export type EmailTemplatePresence = {
  isContractTemplatePresent?: boolean | null;
  isProposalTemplatePresent?: boolean | null;
  isPiTemplatePresent?: boolean | null;
  isEnquiryTemplatePresent?: boolean | null;
  isEnquiryStatus?: boolean | null;
};

export type EmailAttachmentVisibility = {
  shouldAttachContract: boolean;
  shouldAttachProposal: boolean;
  shouldAttachPi: boolean;
  shouldAttachEnquiryDetails: boolean;
};

/** Show attach checkboxes only when the matching template is uploaded. Enquiry replaces contract. */
export const getEmailAttachmentVisibility = ({
  isContractTemplatePresent,
  isProposalTemplatePresent,
  isPiTemplatePresent,
  isEnquiryTemplatePresent,
  isEnquiryStatus,
}: EmailTemplatePresence): EmailAttachmentVisibility => {
  const shouldAttachEnquiryDetails = Boolean(isEnquiryTemplatePresent && isEnquiryStatus);
  return {
    shouldAttachContract: Boolean(isContractTemplatePresent) && !shouldAttachEnquiryDetails,
    shouldAttachProposal: Boolean(isProposalTemplatePresent),
    shouldAttachPi: Boolean(isPiTemplatePresent),
    shouldAttachEnquiryDetails,
  };
};

const isChecked = (id: string) => Boolean((document.getElementById(id) as HTMLInputElement | null)?.checked);

export const appendEmailAttachmentOptions = (formData: FormData, visibility: EmailAttachmentVisibility) => {
  if (visibility.shouldAttachContract) {
    formData.append('attachContract', String(isChecked('attachContract')));
  }
  if (visibility.shouldAttachPi) {
    formData.append('attachPI', String(isChecked('attachPI')));
  }
  if (visibility.shouldAttachProposal) {
    formData.append('attachProposal', String(isChecked('attachProposal')));
  }
  if (visibility.shouldAttachEnquiryDetails) {
    formData.append('attachEnquiry', String(isChecked('attachEnquiry')));
  }
};
